import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, UrlTree } from '@angular/router';
import { AuthService } from 'src/app/shared/services/auth.service';
import { FusionAuthService } from 'src/app/shared/services/fusion-auth.service';

@Injectable({
  providedIn: 'root',
})
// TODO Get rid of LogoutGuard once the_tools_cut_over_to_fusion_auth_sign_in_hosted_uis FF is removed.
/**
 * This guard is intended to use in /logout route to make logout process seamless.
 * The canActivate method is dispatching logout action from AuthService and then returning
 * the URL tree which is created using Router which points at /login route. That way
 * navigation to /logout route performs user logout as expected and takes user back to login page.
 */
export class LogoutGuard {
  constructor(
    private auth: AuthService,
    private router: Router,
    private fusionAuthService: FusionAuthService,
  ) {}

  async canActivate(route: ActivatedRouteSnapshot): Promise<UrlTree | boolean> {
    // Using location.href to log the actual URL of where the logout was triggered
    console.log('[LOGOUT GUARD] Trigger:', location.href, route.queryParams?.trigger);
    if (this.fusionAuthService.isFusionAuthConnectionEnabled) {
      this.fusionAuthService.oAuthLogout();
      return true;
    }
    await this.auth.logout();
    return this.router.createUrlTree(['/login']);
  }
}
